/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const defaultLanguageEnumSchema = z
	.enum(["ru", "en", "es", "ar", "zh", "kk", "hy", "ka", "az", "uz"])
	.describe(
		"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
	);
